import React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import { Box } from "@mui/material";
import Title from "../../components/title";
import { experiences } from "./helper";

const Experience = () => {
  return (
    <Box sx={{ mt: 5 }}>
      <Title title="Work Experences" />
      <Box className="secondary-bg rounded-lg">
        <Timeline
          sx={{
            [`& .${timelineItemClasses.root}:before`]: {
              flex: 0,
              padding: 0,
            },
            mt: 5,
          }}
        >
          {experiences?.map((item) => (
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ paddingTop: 0 }} className="text-white">
                <h6 className="primary-text">{item?.designation}</h6>
                <p>{item?.company}</p>
                <small>
                  <i>{item?.duration}</i>
                </small>
                <br />
                <div className="mt-2 ml-2">
                  <ul className="gray-text">
                    {item?.responsibilities?.map((data) => (
                      <li>{data}</li>
                    ))}
                  </ul>
                </div>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </Box>
    </Box>
  );
};

export default Experience;
